import {FC, useContext, useState} from 'react';

import {Stack} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import DownloadIcon from '@mui/icons-material/Download';
import {EventBusContext} from '../../../providers/EventBus';
import {ServiceRequestService} from '../../../api/services/serviceRequest.service';
import {DocumentService} from '../../../api/services/document.service';
import {resolveAndDownloadBlob} from '../../../shared/helpers/resolveAndDownloadBlob';

export const ReportForma: FC = () => {
  const [loading, setLoading] = useState(false);
  const {bus} = useContext(EventBusContext);

  const downloadReport = async () => {
    try {
      setLoading(true);
      const {
        data: {id, fileName},
      } = await ServiceRequestService.getCurrentStateReport();

      const resReport = await DocumentService.getContent(id);

      resolveAndDownloadBlob(resReport, fileName);
    } catch (error) {
      bus?.emit('error', [error]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Stack sx={{px: 4, py: 4}} spacing={3}>
      <Stack direction="row" spacing={2} sx={{alignItems: 'flex-start'}}>
        <LoadingButton
          startIcon={<DownloadIcon />}
          variant="outlined"
          loading={loading}
          onClick={downloadReport}
          sx={{
            backgroundColor: 'white',
          }}
        >
          Скачать отчет
        </LoadingButton>
      </Stack>
    </Stack>
  );
};
